import { styled } from '@mui/material/styles'
import AccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary'

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: 'bold',
  backgroundColor: 'rgba(0, 0, 0, .03)',
  border: '1px solid rgba(0, 0, 0, .125)',
  marginBottom: -1,
  minHeight: 45,
  flexDirection: 'row-reverse',
  padding: '0 16px',
  cursor: 'pointer',
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    transform: 'rotate(0deg)',
    marginRight: '16px',
    '&.Mui-expanded': {
      transform: 'rotate(180deg)',
      marginRight: '16px'
    }
  },
  [`& .${accordionSummaryClasses.content}`]: {
    alignItems: 'center'
  }
}))

